import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILookupItem } from '../../types/genericTypes';
import { getRoleList } from '../API/roleApi';
import type { RootState } from '../store/store';
import { transformForLookupList } from '../transform/transformLookup';


export interface IRole {
    [key: string]: any;
}

interface RoleState {
    roleList: IRole[],
    roleLookup: ILookupItem[]
}

// Define the initial state using that type
const initialState: RoleState = {
    roleList: [],
    roleLookup: []
};

export const callGetRoleList = createAsyncThunk(
    'roles/getRoleList',
    async (args, { dispatch }) => {
        const response = await getRoleList();
        dispatch(setRoleList(response.data.data));
        dispatch(setRoleLookup(transformForLookupList(response.data.data, 'displayName')))
    }
);

export const roleSlice = createSlice({
  name: 'role',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setRoleList: (state, action: PayloadAction<IRole[]>) => {
        state.roleList = action.payload;
    },
    setRoleLookup: (state, action: PayloadAction<ILookupItem[]>) => {
        state.roleLookup = action.payload;
    }
  }
});

export const {
  setRoleList,
  setRoleLookup
} = roleSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectRoleList = (state: RootState): IRole[] => state.role.roleList;
export const selectRoleLookup = (state: RootState): ILookupItem[] => state.role.roleLookup;

export default roleSlice.reducer;
